import {GenLegend} from '../../generated/serverModels/GenLegend';
import {signal, WritableSignal} from '@angular/core';
import {GenLegendType} from '../../generated/serverModels/GenLegendType';

export class LayerLegend extends GenLegend {
  public imageUrl: WritableSignal<string | undefined> = signal(undefined);

  constructor(legend?: LayerLegend | GenLegend) {
    super(legend);

    if(legend) {
      this.buildImageUrl();
    }
  }

  private getParams(): Record<string, unknown> {
    try {
      return JSON.parse(this.params);
    } catch {
      return {};
    }
  }


  public buildImageUrl(): void {
    switch (this.type) {
      case GenLegendType.GEOSERVER: {
        const options = {
          REQUEST: 'GetLegendGraphic',
          VERSION: '1.0.0',
          FORMAT: 'image/png',
          legend_options: 'forceLabels:on;fontName:Roboto;fontSize:14;',
          ...this.getParams(),
        };

        this.imageUrl.set( `${this.urls[0]}?${Object.entries(options).map(entry => `${entry[0]}=${entry[1]}`).join('&')}`);
        break;
      }
    }
  }
}
